<template lang="pug">
.flow-step-wrap.no-select
  .circle(v-for="(step, key) in flow.steps",:class="{actived: flow.actived == key, finish: key <= finish}")
    .number {{ key }}
</template>

<script>
// import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'flowStep',
  props: {
    flow: {}
  },
  data () {
    return {
      finish: 0
    }
  },
  methods: {
    nowStep: function (key) {
      if (this.flow.actived > 0) {
        this.flow.actived = key
        this.finish = key - 1
      }
    },
    nowRoute: function () {
      switch (this.$route.name) {
        case 'ticketType':
          this.flow.actived = 1
          break
        case 'ticketInfo':
          this.flow.actived = 2
          break
        case 'ticketSuccess':
          this.flow.actived = 3
          break
      }
      if (this.flow.actived > 0) {
        this.finish = this.flow.actived
      }
    }
  },
  mounted () {
    this.nowRoute()
  },
  watch: {
    $route: function () {
      this.nowRoute()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
$bar-width: 20px
$dark: #484b53
$green: #20a896

.flow-step-wrap
  margin-top: 40px
  margin-bottom: 40px
  .circle
    position: relative
    background-color: $dark
    +border-radius(50%)
    width: 26px
    height: 26px
    display: inline-block
    text-align: center
    margin-right: $bar-width
    +transition(all, 0.3s, ease)
    &:not(:last-child):after
      content: ''
      display: inline-block
      width: $bar-width
      height: 3px
      background-color: $dark
      position: absolute
      top: 50%
      left: 100%
      +transition(all, 0.3s, ease)
    &.finish
      background-color: $green
      &:not(:last-child):after
        background-color: $green
    &.actived
      background-color: #fff
      transform: scale(1.3)
      transform-origin: center
      color: $black
      &:not(:last-child):after
        background-color: #fff
      & + .circle
        background-color: #fff
        color: $black
    .number
      line-height: 30px
</style>



// WEBPACK FOOTER //
// flowStep.vue?b73cb5c8